import { useSiteCountryCode } from '@common/hooks/localisation';

export function useGetPostJobLink() {
  const countryCode = useSiteCountryCode();

  return { postJobLink: `/${countryCode}/post-job` };
}
